export enum FundDiseaseType {
  All = 'all',
  Selected = 'selected',
}
